// extracted by mini-css-extract-plugin
export var accountRequirements = "zPMaU";
export var button = "h5l29";
export var buttons = "_7ZdHs";
export var link = "EIU6X";
export var main = "aj4eV";